import { render, staticRenderFns } from "./CustomSubIdPerformance.vue?vue&type=template&id=0d602cf4&"
import script from "./CustomSubIdPerformance.vue?vue&type=script&lang=js&"
export * from "./CustomSubIdPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports